"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"
import { getLocalizedTaxonomyTitle } from "@lib/product-content-localization"
import { HttpTypes } from "@medusajs/types"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import CatalogHero from "@modules/store/components/catalog-hero"

export default function CategoryHero({
  category,
  parents,
  image,
}: {
  category: HttpTypes.StoreProductCategory
  parents: HttpTypes.StoreProductCategory[]
  image?: string | null
}) {
  const { locale, t } = useFrontendPreferences()
  const children = category.category_children ?? []

  return (
    <CatalogHero
      title={getLocalizedTaxonomyTitle(category.name, locale)}
      titleTestId="category-page-title"
      description={category.description}
      image={image}
      count={category.products?.length}
      crumbs={parents.map((parent) => ({
        label: getLocalizedTaxonomyTitle(parent.name, locale),
        href: `/categories/${parent.handle}`,
      }))}
    >
      {children.length > 0 && (
        <div className="sahil-hero__subs">
          <span>{t.categoryIndex.subcategories}</span>
          <ul>
            {children.map((child) => (
              <li key={child.id}>
                <LocalizedClientLink
                  href={`/categories/${child.handle}`}
                  className="sahil-filters__chip"
                >
                  {getLocalizedTaxonomyTitle(child.name, locale)}
                </LocalizedClientLink>
              </li>
            ))}
          </ul>
        </div>
      )}
    </CatalogHero>
  )
}
